module.exports = __webpack_public_path__ + "static/media/date-range.34e3c008.svg";